export interface RegisterInterLibraryLoanCollectionRequest {
  id: number
  materialFormat: string
  titleDisplay: string
  titleKana: string
  authorDisplay: string
  authorKana: string
  authorNo: string
  publisherDisplay: string
  publisherKana: string
  publisherNo: string
  isbn: string
  etcType: string
  etcNo: string
  classNo: string
  collectionNo: string
  holdingBranchCode: string
  collectionType: string
  handlingType: string
  appendixCode: string
  interlibraryLoanCode: string
  requestAdDate: string
  borrowingDate: string
  borrowingDueDate: string
  mark: string
  ndc: string
  book: string
  sub: string
  workMemo: string
  displayMemo: string
  localMemo: string
  _reserveAssign?: boolean
}

export function RegisterInterLibraryLoanCollectionRequestToJSON(
  value: RegisterInterLibraryLoanCollectionRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    material_format:
      value.materialFormat !== '' ? value.materialFormat : undefined,
    title_display: value.titleDisplay !== '' ? value.titleDisplay : undefined,
    title_kana: value.titleKana !== '' ? value.titleKana : undefined,
    author_display:
      value.authorDisplay !== '' ? value.authorDisplay : undefined,
    author_kana: value.authorKana !== '' ? value.authorKana : undefined,
    author_no: value.authorNo !== '' ? value.authorNo : undefined,
    publisher_display:
      value.publisherDisplay !== '' ? value.publisherDisplay : undefined,
    publisher_kana:
      value.publisherKana !== '' ? value.publisherKana : undefined,
    publisher_no: value.publisherNo !== '' ? value.publisherNo : undefined,
    isbn: value.isbn !== '' ? value.isbn : undefined,
    etc_type: value.etcType !== '' ? value.etcType : undefined,
    etc_no: value.etcNo !== '' ? value.etcNo : undefined,
    class_no: value.classNo !== '' ? value.classNo : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined,
    holding_branch_code:
      value.holdingBranchCode !== '' ? value.holdingBranchCode : undefined,
    collection_type:
      value.collectionType !== '' ? value.collectionType : undefined,
    handling_type: value.handlingType !== '' ? value.handlingType : undefined,
    appendix_code: value.appendixCode !== '' ? value.appendixCode : undefined,
    interlibrary_loan_code:
      value.interlibraryLoanCode !== ''
        ? value.interlibraryLoanCode
        : undefined,
    request_ad_date:
      value.requestAdDate !== '' ? value.requestAdDate : undefined,
    borrowing_date:
      value.borrowingDate !== '' ? value.borrowingDate : undefined,
    borrowing_due_date:
      value.borrowingDueDate !== '' ? value.borrowingDueDate : undefined,
    mark: value.mark !== '' ? value.mark : undefined,
    ndc: value.ndc !== '' ? value.ndc : undefined,
    book: value.book !== '' ? value.book : undefined,
    sub: value.sub !== '' ? value.sub : undefined,
    work_memo: value.workMemo !== '' ? value.workMemo : undefined,
    display_memo: value.displayMemo !== '' ? value.displayMemo : undefined,
    local_memo: value.localMemo !== '' ? value.localMemo : undefined,
    _reserve_assign: value._reserveAssign ?? undefined
  }
}
